<script lang="ts" setup>
// Feuille des intervenants du dossier (port de MobileTeamSheet).
import type { MobileTeamMember } from './mobileMockData';

defineProps<{ team: MobileTeamMember[] }>();
const emit = defineEmits<{ close: [] }>();
</script>

<template>
  <MobileSheet
    title="Intervenants"
    :count="team.length"
    @close="emit('close')"
  >
    <div
      v-for="c in team"
      :key="c.initials"
      class="gm-team-row"
    >
      <span :class="['gm-team-av', 'lg', `tone-${c.tone}`]">{{ c.initials }}</span>
      <span class="gm-team-info">
        <span class="gm-team-name">{{ c.name }}</span>
        <span class="gm-team-role">{{ c.role }}</span>
      </span>
    </div>
  </MobileSheet>
</template>
